import { useMemo } from "react";
import { SupportedLanguage } from "../i18n/supported-language";

const supportedLanguages = new Set(Object.values(SupportedLanguage));

export const getInitialLanguage = (): SupportedLanguage => {
  if (typeof window === "undefined") {
    return SupportedLanguage.English;
  }

  const userLanguages = navigator.languages || [navigator.language];

  // navigator.languages is ordered by preference, so we only need to look
  // at the first match
  // if we want to country-based localization, we have to get rid of the substring() call
  const firstMatch = userLanguages
    .map((language) => language.substring(0, 2) as SupportedLanguage)
    .find((language) => supportedLanguages.has(language));

  return firstMatch ?? SupportedLanguage.English;
};

export const useInitialLanguage = (): SupportedLanguage => useMemo(getInitialLanguage, []);
